module.exports = __webpack_public_path__ + "img/35.85b488a5.jpg";